import React, { useEffect } from 'react';
import { Drawer, Form, Space, Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useMutation } from 'hooks/apollo';
import { gql } from '@apollo/client';
import globalMessages from 'translations/messages';

import EditFunnel from './EditFunnel';
import messages from './messages';

const UPDATE_FUNNEL = gql`
  mutation($funnelId: ID!, $input: JSON!) {
    updateFunnel(funnelId: $funnelId, input: $input) {
      id
      title
      steps {
        id
        title
        sortIndex
        filter {
          id
          surveyGroupId
          displayedSurveyId
          filterSegments {
            id
            filterOptions { id relationId options type }
          }
        }
      }
    }
  }
`;

const REMOVE_FUNNEL = gql`
  mutation($funnelId: ID!) {
    removeFunnel(funnelId: $funnelId) { id }
  }
`;

const EditFunnelDrawer = ({ funnel, open, onClose, onDone, onRemoved }) => {
  const [form] = Form.useForm();
  const [updateFunnelMutation, { loading }] = useMutation(UPDATE_FUNNEL);
  const [removeFunnelMutation, { loading: removing }] = useMutation(REMOVE_FUNNEL);

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open]);

  const onSubmit = async (values) => {
    await updateFunnelMutation({
      variables: {
        funnelId: funnel.id,
        input: values,
      },
    });
    onDone();
  };

  const handleRemove = async () => {
    await removeFunnelMutation({ variables: { funnelId: funnel.id } });
    onRemoved();
  };

  const initialValues = funnel && {
    title: funnel.title,
    websiteId: funnel.website?.id,
    steps: funnel.steps.map(step => ({
      id: step.id,
      title: step.title,
      survey: {
        survey: {
          id: step.filter.displayedSurveyId,
        },
        group: {
          id: step.filter.surveyGroupId,
        },
      },
      filterOptions: step.filter.filterSegments[0]?.filterOptions,
    })),
  };

  return (
    <Drawer
      open={open}
      placement="right"
      onClose={onClose}
      width={400}
      title={<FormattedMessage {...messages.editFunnel} />}
      footer={(
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            danger
            onClick={handleRemove}
            loading={removing}
          >
            <FormattedMessage {...globalMessages.delete} />
          </Button>
          <Space>
            <Button
              onClick={onClose}
            >
              <FormattedMessage {...globalMessages.cancel} />
            </Button>
            <Button
              onClick={form.submit}
              type="primary"
              loading={loading}
            >
              <FormattedMessage {...globalMessages.save} />
            </Button>
          </Space>
        </div>
        )}
    >
      <Form layout="vertical" form={form} initialValues={initialValues} onFinish={onSubmit}>
        <EditFunnel website={funnel.website} />
      </Form>
    </Drawer>
  );
};

export default EditFunnelDrawer;
